"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeorgiaRegularItalic = exports.CourierNewBold = exports.AvenirNextBold = exports.AvenirNextRegular = exports.ProximaNovaSemibold = exports.ProximaNovaRegular = exports.SourceSansProSemiBold = exports.SourceSansProRegular = exports.BoltonBold = exports.BoltonRegular = void 0;
exports.BoltonRegular = {
    name: 'F37 Bolton',
    family: `'F37 Bolton', Helvetica, Arial, sans-serif`,
    style: 'Regular',
    weight: 400,
    emSquareRatio: 1.25,
    tracking: 0,
};
exports.BoltonBold = {
    ...exports.BoltonRegular,
    style: 'Bold',
    weight: 700,
};
exports.SourceSansProRegular = {
    name: `Source Sans Pro`,
    family: `'Source Sans Pro', Helvetica, Arial, sans-serif`,
    style: 'Regular',
    weight: 400,
    emSquareRatio: 1.25,
    tracking: 0,
};
exports.SourceSansProSemiBold = {
    ...exports.SourceSansProRegular,
    style: `SemiBold`,
    weight: 600,
};
exports.ProximaNovaRegular = {
    name: `Proxima Nova`,
    family: `'Proxima Nova', Helvetica, Arial, sans-serif`,
    style: 'Regular',
    weight: 400,
    emSquareRatio: 1.22,
    tracking: 0,
};
exports.ProximaNovaSemibold = {
    ...exports.ProximaNovaRegular,
    style: 'Semibold',
    emSquareRatio: 1,
    weight: 600,
};
exports.AvenirNextRegular = {
    name: `Avenir Next`,
    family: `'Avenir Next', Helvetica, Arial, sans-serif`,
    style: 'Regular',
    weight: 400,
    emSquareRatio: 1.37,
    tracking: 0,
};
exports.AvenirNextBold = {
    ...exports.AvenirNextRegular,
    style: 'Bold',
    weight: 700,
};
exports.CourierNewBold = {
    name: 'Courier New',
    family: `'Courier New', monospace`,
    style: 'Bold',
    weight: 700,
    emSquareRatio: 1.13,
    tracking: 0,
};
exports.GeorgiaRegularItalic = {
    name: `Georgia`,
    family: `'Georgia', serif`,
    style: `Italic`,
    weight: 400,
    emSquareRatio: 1.13,
    tracking: 0,
};
//# sourceMappingURL=fonts.js.map